import { Col, Divider, Row, Space, Tooltip } from "antd";
import CustomNoData from "apps/Common/CustomNoData";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import "apps/layout/Header/custom.css";
import { Link } from "react-router-dom";

const CategoryItem = (props: any) => {
  const handleHover = (index: number) => {
    props.setActiveItemIndex(index);
  };

  const handleClick = (index: number) => {
    props.setActiveItemIndex(index);
  };



  return (
    <>
      <div className="!flex gap-1 !relative items-center !mt-1 main-category-item !w-auto !h-[35px] !z-40">
        <Space>
          <LazyLoadImage
            wrapperWidth="15px"
            wrapperHeight="15px"
            style={{ objectFint: "fill" }}
            src={props.item.icon.fileName}
            alt=""
          />

          <Link className="!text-black !font-bold sm:!font-normal !text-base sm:!text-sm " to={props.item.url}>
            <span className="cursor-pointer">{props.item.title}</span>
          </Link>
        </Space>

        <div className={`!absolute top-8 left-18 !bg-white !z-30 !py-2 !pl-4 rounded-lg ${props.item.title?.toLowerCase()?.trim()==="arsa"?"!w-[200px]":"!w-[630px]"} !shadow-2xl sub-category-items !h-[300px] `}>
          <Row gutter={[10, 10]}>
            <Col xs={24} lg={props.item.title?.toLowerCase()?.trim()==="arsa"?24:8} 
            >
              {props.item.children.map((item: any, index: number) => (
                <div
                  className="!w-full"
                  key={index}
                  onMouseEnter={() => handleHover(index)}
                  onClick={() => handleClick(index)}
                >
                  <Col span={24} className="!py-2">
                    <Link
                      to={item.url}
                      className={`hover:cursor-pointer ${
                        props.activeItemIndex === index
                          ? "hover:!text-[#1677ff] "
                          : ""
                      }`}
                    >
                      {item.title}
                    </Link>
                  </Col>
                  <Col span={24}>
                    <Divider className="!m-0" />
                  </Col>
                </div>
              ))}
            </Col>
            {
             props.item.title?.toLowerCase()?.trim()!=="arsa"&&
            <Col xs={24} lg={16} className="!py-2 !px-4 !h-full">
              {props.activeItemIndex !== null && (
                <Row gutter={[10, 10]}>
                  {props.item.children[props.activeItemIndex]?.children
                    ?.length <= 0 ? (
                    <>
                      {/* <CustomNoData description="Kategori Bulunamadı" /> */}
                    </>
                  ) : (
                    <>
                      {props.item.children[props.activeItemIndex]?.children.map(
                        (subItem: any, subIndex: number) => (
                          <Col xs={24} md={12} lg={8} key={subIndex} >
                            <Link to={`${subItem.url}`} className="!text-black">
                              <div
                                className="!border-gray-400 !rounded-lg !grid gap-2"
                                style={{ border: "1px solid" }}
                              >
                                <LazyLoadImage
                                  src={subItem?.icon?.fileName}
                                  wrapperHeight="80px"
                                  wrapperWidth="100%"
                                  style={{ objectFit: "cover" }}
                                  classNames="!rounded-lg"
                                  imageClassName="!rounded-t-lg"
                                  alt=""
                                />
                                <div className="!flex justify-center !w-full hover:!text-[#1677ff]">
                                  {subItem.title.length <= 17 ? (
                                    <>{subItem.title}</>
                                  ) : (
                                    <>
                                      <Tooltip title={subItem.title}>
                                        {subItem.title.slice(0, 17)}
                                      </Tooltip>
                                    </>
                                  )}
                                </div>
                              </div>
                            </Link>
                          </Col>
                        )
                      )}
                    </>
                  )}
                </Row>
              )}
            </Col>
            }
          </Row>
        </div>
      </div>
    </>
  );
};

export default CategoryItem;
